import { render, staticRenderFns } from "./ManageReviews.vue?vue&type=template&id=4625cf6a&scoped=true&"
import script from "./ManageReviews.vue?vue&type=script&lang=js&"
export * from "./ManageReviews.vue?vue&type=script&lang=js&"
import style0 from "./ManageReviews.vue?vue&type=style&index=0&id=4625cf6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4625cf6a",
  null
  
)

export default component.exports